<template>
  <el-button-group v-if="reconcilables && Object.keys(reconcilables).length">
    <el-button
      v-if="reconcilables.ap && reconcilables.ap.data.length"
      :type="activeTab === 'ap' ? 'primary' : null"
      :class="activeTab === 'ap' ? 'focussedBtn' : 'unfocussedBtn'"
      @click="!(activeTab === 'ap') ? $emit('changeTabs', 'ap') : false">
      Accounts Payable
    </el-button>
    <el-button
      v-if="reconcilables.pc && reconcilables.pc.data.length"
      :type="activeTab === 'pc' ? 'primary' : null"
      :class="activeTab === 'pc' ? 'focussedBtn' : 'unfocussedBtn'"
      @click="!(activeTab === 'pc') ? $emit('changeTabs', 'pc') : false">
      Petty Cash
    </el-button>
    <el-button
      v-if="reconcilables.je && reconcilables.je.data.length"
      :type="activeTab === 'je' ? 'primary' : null"
      :class="activeTab === 'je' ? 'focussedBtn' : 'unfocussedBtn'"
      @click="!(activeTab === 'je') ? $emit('changeTabs', 'je') : false">
      Journal Entries
    </el-button>
    <el-button
      v-if="reconcilables.checks && reconcilables.checks.data.length"
      :type="activeTab === 'checks' ? 'primary' : null"
      :class="activeTab === 'checks' ? 'focussedBtn' : 'unfocussedBtn'"
      @click="!(activeTab === 'checks') ? $emit('changeTabs', 'checks') : false">
      Checks
    </el-button>
    <el-button
      v-if="reconcilables.payments && reconcilables.payments.data.length"
      :type="activeTab === 'payments' ? 'primary' : null"
      :class="activeTab === 'payments' ? 'focussedBtn' : 'unfocussedBtn'"
      @click="!(activeTab === 'payments') ? $emit('changeTabs', 'payments') : false">
      EFT/WR/MC
    </el-button>
  </el-button-group>
</template>

<script>
  export default {
    props: {
      reconcilables: {
        'type': Object,
        'required': true
      },
      activeTab: {
        'type': String,
        'default': 'all'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Programs/BankRecon/BankRecTabs.vue